import angular from "angular";
import component from "./active-operations.component";

angular.module('activeOperations', [component]);

export default "activeOperations";


// WEBPACK FOOTER //
// ./resources/assets/modules/active-operations/active-operations.module.js